import http from '@utils/http';
import httpAxios from '@utils/httpAxios'
const $ = window.Zepto;

function objToStr(params) {
  let arr = [];
  for (const key in params) {
    arr.push(`${key}=${params[key]}`);
  }
  let str = arr.join('&');
  return str;
}

// 获取openId
export function apiGetOpenId(code) {
  return http
    .get('/phoenix/phoenix/arctic/v1/wx/viewOpenId', { code,weChatOfficialAccountType: localStorage.getItem('weChatOfficialAccountType') || ''})
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}

// 手机验证码
export function ApiGetVerify(mobile) {
  const config = {
    dataType: 'json',
    contentType: 'application/json',
  };

  return http
    .post(
      '/phoenix/phoenix/arctic/v1/user/verify',
      JSON.stringify({ mobile, msgType: 3 }),
      {},
      config
    )
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}

// 手机登录 - 商户登录
export function apiGetUserLogin_sh(data) {
  const headers = {
    accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const config = {
    dataType: 'json',
    contentType: 'application/json',
  };
  let body = {
    ...data,
    weChatOfficialAccountType:localStorage.getItem('weChatOfficialAccountType') || ''
  }
  return httpAxios
    .post(
      '/phoenix/phoenix/arctic/v1/merchant/user/login',
      JSON.stringify(body),
      headers,
      config
    )
    .then(res => {
      return res;
    });
}

// 手机登录 - 商管登录
export function apiGetUserLogin_sg(params) {
  // const config = {
  //   dataType: 'json',
  //   contentType: 'application/json',
  // };
  let body = {
    ...params,
    weChatOfficialAccountType:localStorage.getItem('weChatOfficialAccountType') || ''
  }
  let str = objToStr(body);
  return http
    .post(`/phoenix/phoenix/arctic/v1/user/managementLogin?${str}`)
    .then(res => {
      console.log(res);
      // roleType  0游客
      return res;
    }).catch(err=>{
      console.log(err);
    })
}

// 获取用户店铺信息
export function apiGetStore(userId) {
  return http
    .get(`/aggregation/aggregation/v1/user/bind/store/${userId}`)
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}

// 获取保险列表
export function getInsuranceList() {
  return http.get('/workscene/workscene/v1/insurance/configured').then(res => {
    if (res.status === 200) {
      return res.data;
    } else {
      throw res;
    }
  });
}

// 商户险种列表接口
export function ApiGetInsuranceList(params) {
  return http
    .get('/base/base/v1/insurancePerfect/store/insurance/list', params)
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}

// 查看保单详情
export function ApiGetInsurDetail(params) {
  return http.get('/base/base/v1/insurancePerfect/detail', params).then(res => {
    if (res.status === 200) {
      return res.data;
    } else {
      throw res;
    }
  });
}

// 上传已购保单接口
export function ApiGetInsurUpload(params) {
  const config = {
    dataType: 'json',
    contentType: 'application/json',
  };

  return http
    .post(
      '/base/base/v1/insurancePerfect/upload',
      JSON.stringify(params),
      {},
      config
    )
    .then(res => {
      return res
    });
}

// 获取微信jsapi_ticket
export function ApiGetTicket() {
  return http.get(`/phoenix/phoenix/arctic/v1/wx/getJsApiTicket?weChatOfficialAccountType=${localStorage.getItem('weChatOfficialAccountType') || ''}`).then(res => {
    if (res.status === 200) {
      return res.data;
    } else {
      throw res;
    }
  });
}

// 获取access_token
export function ApiGetAccess_token() {
  return http.get('/phoenix/phoenix/arctic/v1/wx/getAccessToken').then(res => {
    if (res.status === 200) {
      return res.data;
    } else {
      throw res;
    }
  });
}
// 查询分享记录
export function ApiGetShareDetail(params,userIdToken) {
  let headers = {
    userIdToken
  }
  return http.get('/base/base/v1/insurancePerfect/share/detail/list',params,headers).then(res => {
    if (res.status === 200) {
      return res.data;
    } else {
      throw res;
    }
  });
}

// 获取保险页面投保商户身份
export function merchantIdentity(data) {
  return http.post('/base/base/v1/notWanda/insurance/view/merchantIdentity/',data).then(res => {
    if (res.status === 200) {
      return res.data;
    } else {
      throw res;
    }
  });
}

// 通过智慧商业小程序token获取用户信息
// /phoenix/arctic/v1/merchant/user/queryByZhsyMiniProgramToken
export function ApiGetMiniInfo(params) {
  return http.get('/phoenix/phoenix/arctic/v1/merchant/user/queryByZhsyMiniProgramToken', params).then(res => {
    if (res.status === 200) {
      return res.data;
    } else {
      throw res;
    }
  });
}

